const Luminous = require('luminous-lightbox').Luminous;
const LuminousGallery = require('luminous-lightbox').LuminousGallery;
// import 'luminous-lightbox/dist/luminous-basic.min.css';

'use strict'
let map
let geocoder
let latLng
let zoom = 15
let mapOptions
let marker
let markers
let infoWindow
let googleMapApiKey
let facility_lists
let barrierFreeIds

let footerNavbarElement
let navbarCollapseElement
let leftContainerElement
let facilityDetailElement

let mapElement
let areaElement
let areaIdElement
let streetElement
let latitudeElement
let longitudeElement
let selectFacilityTypeElements
let searchFacilityNameElement
let btnSearchFacilityNameElement

let serviceBaseUrl
let facilityUrl
let facilitySearchUrl
let facilitiesKey
let facilityKey

let selectedFacilityTypeId
let selectedAreaId

let luminousElemCaption
let luminousGalleryElems

//オプションの設定
const luminousOpts = {
  caption: (trigger) => {
    //a 要素に data-caption 属性が設定されていて、その値が空でない場合
    if(trigger.hasAttribute('data-caption') && trigger.getAttribute('data-caption') !== '') {
      //a 要素の data-caption 属性の値をキャプションとして表示
      return trigger.getAttribute('data-caption');
    }else{
      //a 要素の data-caption 属性が設定されていなければ img 要素の alt 属性の値を表示
      return trigger.querySelector('img').getAttribute('alt');
    }
  },
}

document.addEventListener('DOMContentLoaded', function() {
  Facilities.init()
  setEventListener()
  // SP Height Change
  if (!facilityDetailElement) {
    if(mapElement) {
      if (Facilities.mobileAccess()) {
        mapElement.style.height = "55vh"
      }
    }
    Facilities.initMap()
  } else {
    Facilities.initDetailMap()
  }

  // ToucEvent
  let startX
  let startY
  let moveX
  let moveY
  let dist = 30
  let distY = 60

  if(footerNavbarElement) {
    footerNavbarElement.addEventListener('touchstart', function(e) {
      startX = e.touches[0].pageX
      startY = e.touches[0].pageY
    })
    footerNavbarElement.addEventListener('touchmove', function(e) {
      e.preventDefault()
      moveX = e.changedTouches[0].pageX
      moveY = e.changedTouches[0].pageY
    })
    footerNavbarElement.addEventListener('touchend', function(e) {
      var index
      if(moveX == undefined || moveX == 0){
        // スワイプなし時の処理
      }
      else if (startX > moveX && startX > moveX + dist) {
        // 右から左にスワイプした時の処理
        if (startY < moveY && startY + distY < moveY) {
          // 上から下にスワイプした時の処理
          if(navbarCollapse){
            if (navbarCollapse.classList.contains("show")) {
              navbarCollapse.classList.remove("show")
            }
          }
        }
        else if(facilityDetail) {
          Facilities.next()
        }
      }
      else if (startX < moveX && startX + dist < moveX) {
        // 左から右にスワイプした時の処理
        // 下から上にスワイプした時の処理
        if (startY > moveY && startY > moveY + distY) {
          if(navbarCollapse){
            if (!navbarCollapse.classList.contains("show")) {
              navbarCollapse.classList.add("show")
            }
          }
        }
        else if(facilityDetail) {
          Facilities.prev()
        }
      }
      else if (startY < moveY && startY + distY < moveY) {
        // 上から下にスワイプした時の処理
        if(navbarCollapse){
          if (navbarCollapse.classList.contains("show")) {
            navbarCollapse.classList.remove("show")
          }
        }
      }
      else {
      }

      startX = 0
      startY = 0
      moveX = 0
      moveY = 0
    })
  }
})
function setEventListener() {
  // Area button click
  var btnAreas = document.querySelectorAll(".btn-area");
  btnAreas.forEach(function(target) {
    target.addEventListener('click', function(e) {
      Facilities.changeMap(e.currentTarget)
    })
  })

  // Map button click
  var facilityMaps = document.querySelectorAll(".facility-map");
  facilityMaps.forEach(function(target) {
    target.addEventListener('click', function(e) {
      Facilities.panTo(e.currentTarget)
    })
  })
  // section scroll
  var btnSections = document.querySelectorAll(".btn-section");
  btnSections.forEach(function(target) {
    target.addEventListener('click', function(e) {
      Facilities.scrollToSection(e.currentTarget)
    })
  })

  // section scroll
  if (!facilityDetailElement) {
    var btnBarrierFrees = document.querySelectorAll(".btn-barrier-free");
    btnBarrierFrees.forEach(function(target) {
      target.addEventListener('click', function(e) {
        Facilities.selectBarrierFree(e.currentTarget)
      })
    })
  }

  // Facility Type
  if (selectFacilityTypeElements) {
    selectFacilityTypeElements.forEach(function(target) {
      target.addEventListener('change', function(e) {
        Facilities.changeFacilityType(e.currentTarget)
      })
      target.addEventListener('blur', function(e) {
        Facilities.changeFacilityType(e.currentTarget)
      })
    })
  }

  // facility selected
  var facilities = document.querySelectorAll(".facility")
  if (facilities) {
    facilities.forEach(function(target) {
      // target.style.display = "none"
      target.classList.add("selected")
    })
  }

  if(btnSearchFacilityNameElement) {
    btnSearchFacilityNameElement.addEventListener("click", function(e) {
      Facilities.setResult()
    })
  }

  var languageTypes = document.querySelectorAll(".language-type")
  if (languageTypes) {
    languageTypes.forEach(function(target) {
      target.addEventListener('click', function(e) {
        Facilities.setLocale(e.currentTarget)
      })
    })
  }


  luminousGalleryElems = document.querySelectorAll('.luminous');
  if( luminousGalleryElems.length > 0 ) {
    new LuminousGallery(luminousGalleryElems, {}, luminousOpts);
  }

}
function GetQueryString() {
  if (1 < document.location.search.length) {
    var query = document.location.search.substring(1);
    var parameters = query.split('&');
    var result = new Object();
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split('=');
      var paramName = decodeURIComponent(element[0]);
      var paramValue = decodeURIComponent(element[1]);
      result[paramName] = decodeURIComponent(paramValue);
    }
    return result;
  }
  return null;
}
var Facilities = {
  init: function(){
    facilityDetailElement = document.getElementById("facility_detail")
    footerNavbarElement = document.getElementById("footer_navbar")
    navbarCollapseElement = document.getElementById("navbar")
    leftContainerElement = document.getElementById("left_container")

    mapElement = document.getElementById("map")
    areaIdElement = document.getElementById("facility_area_id")
    areaElement = document.getElementById("facility_area_code")
    streetElement = document.getElementById("facility_addresses_attributes_0_street")
    latitudeElement = document.getElementById("facility_addresses_attributes_0_latitude")
    longitudeElement = document.getElementById("facility_addresses_attributes_0_longitude")
    selectFacilityTypeElements = document.querySelectorAll(".select-facility-type")
    searchFacilityNameElement = document.getElementById("facility_name")
    btnSearchFacilityNameElement = document.getElementById("btn_search_facility_name")

    serviceBaseUrl = location.origin
    facilityUrl= serviceBaseUrl + "/api/v1/facilities.json"
    facilitySearchUrl = serviceBaseUrl + "/api/v1/facilities/search.json"
    facilitiesKey = "facilities"
    facilityKey = "facility"

    googleMapApiKey = "AIzaSyAHTeIkbYyuzdQ2QMe8KmkshwBGeZESooc"
    geocoder = new google.maps.Geocoder();
    barrierFreeIds = []
  },
  initMap: function() {
    var defaultLatitude = 37.7542123
    var defaultLongitude = 140.4640277
    var areaId
    var latitude
    var longitude
    var facilityType

    // var src = 'https://developers.google.com/maps/documentation/javascript/examples/kml/westcampus.kml';
    // var src = 'https://test.barrier-free.sisay.jp/fukushima_city2.kml'
    // var src = 'https://dev-sisay-jp.s3.ap-northeast-1.amazonaws.com/fukushima_city3.kml'


    if(Facilities.storageAvailable('sessionStorage')){
      areaId = sessionStorage.getItem('area_id')
      latitude = sessionStorage.getItem('latitude')
      longitude = sessionStorage.getItem('longitude')
      facilityType = sessionStorage.getItem('facility_type')
      // barrierFreeIds = sessionStorage.getItem('barrier_free_ids')
    }
    if(latitude == null) {latitude = defaultLatitude}
    if(longitude == null) {longitude = defaultLongitude}
    if(areaId == null) {areaId = 0}
    if(facilityType) {
      if (selectFacilityTypeElements) {
        selectFacilityTypeElements.forEach(function(target) {
          var facilityTypeList = target.children
          for(var i=0;i< facilityTypeList.length;i++) {
            if(facilityTypeList[i].value == facilityType) {
              facilityTypeList[i].selected = true
              break
            }
          }
        })
      }
    }
    if(sessionStorage.getItem('barrier_free_ids')){
      barrierFreeIds = sessionStorage.getItem('barrier_free_ids').split(',').map(Number)
      var barrierFreeNodes = document.querySelectorAll(".btn.btn-barrier-free")
      barrierFreeNodes.forEach(function(target) {
        for(var i=0;i<barrierFreeIds.length;i++){
          if(target.dataset.value == barrierFreeIds[i]){
            target.classList.add("selected")
            break
          }
        }
      })
    }
    latLng = new google.maps.LatLng(latitude, longitude)
    if (mapElement) {
      if(this.mobileAccess()){
        mapOptions = {
          zoom: zoom ,
          center: latLng,
          mapTypeId: 'roadmap',
          mapTypeControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP,
            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
          },
          streetViewControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
          },
          fullscreenControlOptions: {
            position: google.maps.ControlPosition.TOP_RIGHT,
          },
          zoomControl: false,
        };
      }else{
        mapOptions = {
          zoom: zoom ,
          center: latLng,
          mapTypeId: 'roadmap',
        };
      }
      map = new google.maps.Map(mapElement, mapOptions);

      // var kmlLayer = new google.maps.KmlLayer(src, {
      //   suppressInfoWindows: true,
      //   preserveViewport: false,
      //   map: map
      // });

      // kmlLayer.addListener('click', function(event) {
      //   var content = event.featureData.infoWindowHtml;
      //   var testimonial = document.getElementById('capture');
      //   testimonial.innerHTML = content;
      // });
    }
    this.searchFacilities(areaId)
  },
  initDetailMap: function() {
    var latitude = 37.7542123
    var longitude = 140.4570277
    var draggable = true
    if (mapElement) {
      if (facilityDetailElement) {
        draggable = false
      }

      if (latitudeElement && longitudeElement) {
        if (latitudeElement.value != "") {
          latitude = parseFloat(latitudeElement.value)
        }
        if (longitudeElement.value != "") {
          longitude = parseFloat(longitudeElement.value)
        }
      }

      latLng = new google.maps.LatLng(latitude,longitude)
      let options = {
        zoom: zoom,
        center: latLng,
        mapTypeId: 'roadmap'
      };
      map = new google.maps.Map(mapElement, options);
      marker = new google.maps.Marker({
        position: latLng,
        draggable: draggable,
        map: map,
        icon: {
          url: '/assets/images/pin3.png',
          scaledSize: new google.maps.Size(32, 43)
        },
        optimized: false
      })
      google.maps.event.addListener(marker, 'dragend', function(e) {
        latitudeElement.value = e.latLng.lat(),
        longitudeElement.value = e.latLng.lng()
      })
      marker.setMap(map)
      map.panTo(latLng)
    }
  },
  changeFacilityType: function(ele) {
    if (ele.classList.contains("select-facility-type")) {
      selectedFacilityTypeId = ele.value
      if(Facilities.storageAvailable('sessionStorage')){
        sessionStorage.setItem('facility_type', selectedFacilityTypeId)
      }
    }
    this.setResult()
  },
  changeMap: function(ele) {
    var areaCode
    var areaId

    areaCode = ele.getAttribute("data-area-code")
    areaId = ele.getAttribute("data-area-id")
    if(Facilities.storageAvailable('sessionStorage')){
      sessionStorage.setItem('area_id', areaId)
    }
    switch (areaCode) {
      case "FukushimaCity":
        Facilities.toFukushimaCity()
        break
      case "Tsuchiyu":
        Facilities.toTsuchiyu()
        break
      case "Takayu":
        Facilities.toTakayu()
        break
      case "Iizaka":
        Facilities.toIizaka()
        break
      case "Suburbs":
        Facilities.toSuburbs()
        break
      default:
        Facilities.toFukushimaCity()
        break
    }
    this.searchFacilities(areaId)
  },
  drawMap: function(latitude, longitude, level) {
    if(latitude && longitude) {
      latLng = new google.maps.LatLng(latitude, longitude)
      map.panTo(latLng)
      if(Facilities.storageAvailable('sessionStorage')){
        sessionStorage.setItem('latitude', latitude)
        sessionStorage.setItem('longitude', longitude)
      }
    }
    if(level != undefined) {
      map.setZoom(level);
    }else {
      map.setZoom(zoom);
    }
  },
  createRequest: function(url, method, data){
    var request = new Request(url, {
      method: method,
      mode: 'cors',
      credentials: 'same-origin',
      headers: new Headers({
        "Content-Type": "application/json",
      }),
      body: data,
      cache: 'no-cache'
    })
    return request
  },
  search: function(address) {
    if(geocoder && address) {
      geocoder.geocode(
        {
          'address': address,
          'region': 'jp'
        },
        function(results, status) {
          if(status==google.maps.GeocoderStatus.OK) {
            if(marker) {
              marker.setMap(null)
              marker = null
            }
            map.setCenter(results[0].geometry.location);
            var bounds = new google.maps.LatLngBounds();
            for (var r in results) {
              if (results[r].geometry) {
                latLng = results[r].geometry.location;
                bounds.extend(latLng)
                marker = new google.maps.Marker({
                  position: latLng,
                  draggable: true,
                  map: map,
                })
                google.maps.event.addListener(marker, 'dragend', function(e) {
                  latitudeElement.value = e.latLng.lat()
                  longitudeElement.value = e.latLng.lng()
                })
                marker.setMap(map)
              }
            }
          }
        }
      )
    }
  },
  searchFacilities: function(val) {
    var hash = {
      "facility": {
        "area_id": val
      }
    }
    var locale = this.getLocale()
    if(locale){
      hash["facility"]["locale"] = locale
    }
    var data = JSON.stringify(hash)
    var request = this.createRequest(facilitySearchUrl, "POST", data)
    fetch(request)
      .then((response) => response.json())
      .then(json => this.addFacilities(json))
      .catch((error) => console.log(error))
  },
  addFacilities: function(json) {
    var facilities = json[facilitiesKey]
    if(facilities) {
      markers && markers.map(m => m.marker.setMap(null));
      markers = []
      facility_lists = []
      var addedFacilities = []
      for (var i = 0; i < facilities.length; i++) {
        var facility = {}
        var latLng
        // var infoWindow
        var _id
        var _title
        var _tel
        var _street
        var _latitude
        var _longitude
        var _url
        var _area_id
        var _facility_type
        var _facility_type_id
        var _facility_type_name
        var _category_structs
        var categories = []
        var marker_info = {}

        _id = facilities[i].id
        _title = facilities[i].name
        _tel = facilities[i].tel
        _url = facilities[i].url
        _area_id = facilities[i].area_id
        _facility_type = facilities[i].facility_type
        _facility_type_id = facilities[i].facility_type_id
        _facility_type_name = facilities[i].facility_type_name

        _category_structs = facilities[i]["category_structs"]

        if (facilities[i].addresses) {
          _street = facilities[i].addresses[0].street
          _latitude = facilities[i].addresses[0].latitude
          _longitude = facilities[i].addresses[0].longitude
        }
        if (_category_structs) {
          for(var iy=0; iy < _category_structs.length; iy++){
            var category = {}
            category.id = _category_structs[iy]["category"]["id"]
            category.name = _category_structs[iy]["category"]["name"]
            category.code = _category_structs[iy]["category"]["code"]
            categories.push(category)
          }
        }
        facility.id = _id
        facility.title = _title
        facility.facility_type = _facility_type
        facility.tel = _tel
        facility.street = _street
        facility.latitude = _latitude
        facility.longitude = _longitude
        facility.url = _url
        facility.area_id = _area_id
        facility.facility_type = _facility_type
        facility.facility_type_id = _facility_type_id
        facility.facility_type_name = _facility_type_name

        facility.categories = categories

        facility_lists.push(facility)

        if(_latitude && _longitude) {
          latLng = {
            lat: parseFloat(_latitude),
            lng: parseFloat(_longitude)
          };
        }
        if(latLng) {
          var _marker = new google.maps.Marker({
            title: _title,
            map: map,
            position: latLng,
            // animation: google.maps.Animation.DROP,
            icon: {
              url: '/assets/images/pin3.png',
              scaledSize: new google.maps.Size(32, 43)
            },
            optimized: false
          });

          _marker.addListener('click', function(e) {
            Facilities.setInfoWindow(e, this)
          });
          marker_info.facility_id = facility.id
          marker_info.title = facility.title
          marker_info.marker = _marker
          markers.push(marker_info)
          _marker.setMap(map)
        }
      }
    }
    this.setResult()
  },
  selectBarrierFree: function(ele) {
    var selectTargetId
    selectTargetId = ele.getAttribute("data-value")
    if (ele.classList.contains("selected")) {
      ele.classList.remove("selected")
      barrierFreeIds = barrierFreeIds.filter(n => n !== selectTargetId);
    } else {
      ele.classList.add("selected")
      barrierFreeIds.push(selectTargetId);
    }
    if(Facilities.storageAvailable('sessionStorage')){
      sessionStorage.setItem('barrier_free_ids', barrierFreeIds)
    }
    this.setResult()
  },
  setResult: function() {
    var facilityNodes = document.querySelectorAll(".facility")
    var facilityName
    if(searchFacilityNameElement){
      facilityName = searchFacilityNameElement.value
    }
    var selectedBarrierFreeNodes = document.querySelectorAll(".btn.btn-barrier-free.selected")
    if(selectedBarrierFreeNodes){
      barrierFreeIds = []
      selectedBarrierFreeNodes.forEach(function(target) {
        barrierFreeIds.push(target.dataset.value)
      })
      if(Facilities.storageAvailable('sessionStorage')){
        sessionStorage.setItem('barrier_free_ids', barrierFreeIds)
      }
    }

    selectedAreaId = sessionStorage.getItem('area_id')
    selectedFacilityTypeId = sessionStorage.getItem('facility_type')

    if(facilityNodes) {
      var results = []
      facilityNodes.forEach(function(target) {
        var result = false
        var facilityId = null
        var areaId = null
        var title = null
        var isTitle = false
        var isArea = false
        var isFacilityType = false
        var isBarrierFreeIds = false
        facilityId = target.dataset.facilityId
        title = target.dataset.title

        if(facilityId){
          facilityId = Number(facilityId)

          if(facilityName) {
            isTitle = title.includes(facilityName)
          }else{
            isTitle = true
          }

          // facility_list との比較
          if(facility_lists) {
            for (var i=0; i < facility_lists.length; i++) {
              if (facility_lists[i].id == facilityId) {
                // area_id との比較
                if(selectedAreaId) {
                  areaId = Number(facility_lists[i].area_id)
                  selectedAreaId = Number(selectedAreaId)
                  if(areaId == selectedAreaId) {
                    isArea = true
                  }else {
                    isArea = false
                  }
                }else {
                  isArea = true
                }

                // facility_type との比較
                if(selectedFacilityTypeId){
                  selectedFacilityTypeId = Number(selectedFacilityTypeId)
                  if(facility_lists[i].facility_type_id == selectedFacilityTypeId) {
                    isFacilityType = true
                  } else {
                    isFacilityType = false
                  }
                } else {
                  isFacilityType = true
                }

                // category との比較
                if(barrierFreeIds.length > 0) {
                  if (facility_lists[i].categories) {
                    var matchCount = 0
                    var _categories = facility_lists[i].categories
                    for(var ib=0; ib<barrierFreeIds.length; ib++){
                      for(var ic=0; ic<_categories.length; ic++){
                        var _bid = Number(barrierFreeIds[ib])
                        var _cid = _categories[ic].id
                        if(_bid == _cid) {
                          matchCount++
                        }
                      }
                    }
                    if (matchCount == barrierFreeIds.length) {
                      isBarrierFreeIds = true
                    } else {
                      isBarrierFreeIds = false
                    }
                  } else {
                    isBarrierFreeIds = false
                  }
                } else {
                  isBarrierFreeIds = true
                }
                break
              }
            }
          }
          if(isTitle && isArea && isFacilityType && isBarrierFreeIds) {
            result = true
          }
        }

        if(result) {
          target.style.display = "block"
          results.push(facilityId)
        } else {
          target.style.display = "none"
        }
      })
    }
    // marker
    if(markers) {
      for(var i=0; i<markers.length;i++){
        markers[i].marker.setMap(null);
        if (results.includes(markers[i].facility_id)) {
          markers[i].marker.setMap(map);
        }
      }
    }
  },
  panTo: function(ele) {
    var latitude = ele.getAttribute("data-latitude")
    var longitude = ele.getAttribute("data-longitude")
    var facility_id = ele.getAttribute("data-facility-id")
    var latLng = new google.maps.LatLng(latitude,longitude)
    if(markers) {
      for(var i=0; i<markers.length;i++){
        if(facility_id == markers[i].facility_id){
          markers[i].marker.setAnimation(google.maps.Animation.BOUNCE);
          // markers[i].marker.setMap(map);
        }else{
          markers[i].marker.setAnimation(null);
        }
      }
    }
    if(mapElement) {
      if (this.mobileAccess()) {
        document.getElementById("sidebarMenuDropdown").click()
      }
    }
    // latLng = new google.maps.LatLng(37.7436845,140.2998417)
    map.panTo(latLng)
  },
  setInfoWindow: function(evt, target) {
    var lang = location.href.substring(location.origin.length+1)
    if (lang.length > 2) {
      lang = lang.substring(0,2)
    } else {
      lang = "ja"
    }
    var detail = "詳細"
    var route = "経路"

    if(lang === 'en') {
      detail = "Detail"
      route = "Route"
    }

    if(facility_lists) {
      for(var i=0; i<facility_lists.length; i++) {
        if(facility_lists[i].title == target.title) {
          var _url = facility_lists[i].url
          var _lang = this.getLocale()
          var _id = facility_lists[i].id

          var _mapUrl = "https://www.google.com/maps/search/?api=1&query=" + facility_lists[i].latitude + "," + facility_lists[i].longitude
          var categories = facility_lists[i].categories

          var SORT_LIST = ['parking_and_facility_1', 'parking_and_facility_2', 'parking_and_facility_3', 'parking_and_facility_4', 'parking_and_facility_5', 'parking_and_facility_6', 'parking_and_facility_14', 'parking_and_facility_7', 'parking_and_facility_13', 'parking_and_facility_8', 'parking_and_facility_9', 'parking_and_facility_10', 'parking_and_facility_11', 'parking_and_facility_12',
            'toilet_1', 'toilet_2', 'toilet_3', 'toilet_4', 'toilet_5', 'toilet_6', 'toilet_7', 'toilet_8', 'toilet_9',
            'transportation_1', 'transportation_2', 'transportation_3', 'transportation_4', 'transportation_5',
            'eating_and_drinking_1', 'eating_and_drinking_2', 'eating_and_drinking_3', 'eating_and_drinking_4', 'eating_and_drinking_5', 'eating_and_drinking_6', 'eating_and_drinking_7', 'eating_and_drinking_8',
            'hotel_accommodation_1', 'hotel_accommodation_2', 'hotel_accommodation_3', 'hotel_accommodation_4', 'hotel_accommodation_5', 'hotel_accommodation_6', 'hotel_accommodation_7', 'hotel_accommodation_8', 'hotel_accommodation_9'
          ]
          categories.sort((a,b) => SORT_LIST.indexOf(a.code) - SORT_LIST.indexOf(b.code))

          _url = location.origin + "/" + _lang + "/facilities/" + _id
          var _content = '<div class="content">'
          _content += '<h3 class="h6 facility-name">' + facility_lists[i].title + '</h3>'
          // if(facility_lists[i].tel) {
          //   _content += '<p class="facility-tel">' + facility_lists[i].tel + '</p>'
          // }
          if(categories) {
            _content += '<div class="facility-barrier-free-section">'
            _content += '<ul class="facility-category-lists x32">'
            for(var ic=0; ic < categories.length;ic++){
              // _content += '<li class="facility-category"><span class="facility-category-code"><i id="' + categories[ic].code + '"'+ ' class="facility-category btn-barrier-free"></i>' + categories[ic].name + '</span></li>'
              _content += '<li tabindex="0" class="facility-category"><span tabindex="0" id="' + categories[ic].code + '"'+ ' class="facility-category-code btn-barrier-free"></li>'
            }
            _content += '</ul>'
            _content += '</div>'
          }
          _content += '<div class="function-section float-left">'
          _content += '<a class="nav-link" href="' + _url + '">'
          _content += '<i class="pe-7s-search"></i>' + detail
          _content += '</a>'
          _content += '<a class="nav-link" href="' + _mapUrl + '">'
          _content += '<i class="pe-7s-map"></i>'　+　route
          _content += '</a>'
          _content += '</div>'
          _content += '</div>'

          if(infoWindow){
            infoWindow.close()
          }

          infoWindow = new google.maps.InfoWindow({
            content: _content
          });

          infoWindow.open(map, target)

          break
        }
      }
    }
  },
  scrollToSection: function(ele) {
    var scrollToTargetId
    var scrollToSection
    var topPos = 0

    scrollToTargetId = ele.getAttribute("data-target")
    scrollToSection = ele.getAttribute("data-section")

    var btnSections = document.querySelectorAll(".btn-section");
    btnSections.forEach(function(target) {
      var target_id = target.getAttribute("data-target")
      var section = target.getAttribute("data-section")
      if (section && section <= scrollToSection) {
        if (target_id) {
          var d = document.getElementById(target_id)
          if (d) {
            topPos = d.offsetTop
          }
        }
      }
    });
    $('#left_container').animate({ scrollTop: topPos}, 'slow');
  },
  show: function(info) {
    this.init()
  },
  prev: function() {
    location.href = location.pathname + "/prev"
  },
  next: function() {
    location.href = location.pathname + "/next"
  },
  setMessage: function(messageText) {
    if(flash_messages){
      flash_messages.innerHTML = ""
      var div = document.createElement("div")
      div.setAttribute("class", "alert alert-danger alert-dismissable flash-message")
      div.innerText = messageText
      var button = document.createElement("button")
      button.setAttribute("type", "button")
      button.setAttribute("class", "close")
      button.setAttribute("data-dismiss", "alert")
      button.setAttribute("aria-hidden", "true")
      button.innerText = "x"
      div.appendChild(button)
      flash_messages.appendChild(div)
    }
  },
  toFukushimaCity: function() {
    var latitude = 37.7542123
    var longitude = 140.4570277
    this.drawMap(latitude, longitude)
  },
  toIizaka: function() {
    var latitude
    var longitude
    if (this.mobileAccess()) {
      latitude = 37.834582
      longitude = 140.447280
    }else{
      latitude = 37.8329513
      longitude = 140.4457622
    }
    this.drawMap(latitude, longitude)
  },
  toTsuchiyu: function() {
    var latitude = 37.6823178
    var longitude = 140.3228764
    this.drawMap(latitude, longitude)
  },
  toTakayu: function() {
    var latitude = 37.7521827
    var longitude = 140.3042912
    this.drawMap(latitude, longitude)
  },
  toSuburbs: function() {
    var latitude = 37.7542123
    var longitude = 140.4570277
    this.drawMap(latitude, longitude, 12)
  },
  mobileAccess: function() {
    var isMobile = false
    if (window.matchMedia && window.matchMedia('(max-device-width: 640px)').matches) {
    isMobile = true
    }
    return isMobile
  },
  storageAvailable: function(type) {
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return e instanceof DOMException && (
            // everything except Firefox
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            (storage && storage.length !== 0);
    }
  },
  getLocale: function() {
    var result = null
    var param = GetQueryString()

    if(this.storageAvailable('sessionStorage')) {
      result = sessionStorage.getItem('language_type')
    } else {
      if(param){
        result = param["locale"]
      }else{
        result = location.pathname.substring(1,3)
      }
      if(result == "fa"){result = "ja"}
    }
    if (result == null) {result = "ja"}
    return result
  },
  setLocale: function(ele) {
    var locale = ele.dataset.locale
    if(this.storageAvailable('sessionStorage')) {
      sessionStorage.setItem('language_type', locale)
    }
  }
}

$(document).on("keydown", function(event) {
  if (event.key === "Enter") {
    // 特定のボタンを取得し、クリックをトリガー
    $("#btn_search_facility_name").click();
  }
});